function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfExclusion = function SvgSelfExclusion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 500 500"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-1.3.2H502v500.5H-1.3z",
    style: {
      fill: "#fd0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 162.4,
    style: {
      fill: "none",
      stroke: "#0054a6",
      strokeWidth: 14,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.9 250 81.5-81.5c2.7-2.7 2.7-7.2 0-9.9s-7.2-2.7-9.9 0L250 240.1l-81.5-81.5c-2.7-2.7-7.2-2.7-9.9 0s-2.7 7.2 0 9.9l81.5 81.5-81.5 81.5c-2.7 2.7-2.7 7.2 0 9.9 1.4 1.4 3.2 2 4.9 2s3.6-.7 4.9-2l81.5-81.5 81.5 81.5c1.4 1.4 3.2 2 5 2s3.6-.7 5-2c2.7-2.7 2.7-7.2 0-9.9z",
    style: {
      fill: "#0054a6"
    }
  }));
};
export default SvgSelfExclusion;